import { PersonIdSchema, type PersonId } from "@thalamos/haven-common";

const UUID = "[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}";
const BARE_ID = new RegExp(`^(${UUID})$`, "i");
const PERSON_PAGE_LINK = new RegExp(`/persons/(${UUID})(?:[/?#]|$)`, "i");

/**
 * The person's id in what somebody pasted: the id itself, or a link to their
 * page. Null for anything else, so a Thalamos admin never searches by what
 * names or describes a child.
 */
export const parsePersonReference = (text: string): PersonId | null => {
  const trimmed = text.trim();
  const found =
    BARE_ID.exec(trimmed)?.[1] ?? PERSON_PAGE_LINK.exec(trimmed)?.[1];
  const parsed = PersonIdSchema.safeParse(found?.toLowerCase());

  return parsed.success ? parsed.data : null;
};
